import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { pageData } from './data';
import { TrophyIcon, CheckCircle2Icon } from 'lucide-react';
export function Bonuses() {
  const {
    bonuses
  } = pageData;
  return <section className="py-20 md:py-24 px-4 bg-navy-900 border-y border-white/5" data-id="element-32">
      <div className="max-w-6xl mx-auto" data-id="element-33">
        <div className="text-center mb-12 md:mb-16" data-id="element-34">
          <div className="w-16 h-16 bg-gold-500/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-35">
            <TrophyIcon className="w-8 h-8 text-gold-500" data-id="element-36" />
          </div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl mb-4" data-id="element-37">
            {bonuses.heading}
          </motion.h2>
          <p className="text-lg text-slate-400" data-id="element-38">{bonuses.subheading}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-39">
          {bonuses.items.map((bonus, idx) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx % 2 * 0.1
        }} className="group relative bg-slate-850 border border-slate-800 rounded-3xl overflow-hidden pl-2 hover:border-gold-500/40 transition-colors duration-300" data-id="element-40">
              {/* Left accent bar */}
              <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gold-500 rounded-l-3xl" data-id="element-41" />

              <div className="p-4 md:p-6" data-id="element-42">
                {/* Image with floating number badge */}
                <div className="relative rounded-2xl overflow-hidden border border-slate-700 bg-navy-950" data-id="element-43">
                  <span className="absolute top-3 left-3 z-10 bg-gold-500 text-navy-950 font-display text-lg md:text-xl px-3 py-1 rounded-lg shadow-lg" data-id="element-44">
                    #{bonus.id}
                  </span>
                  <img src={bonus.image} alt={`Bonus ${bonus.id}: ${bonus.title}`} className="w-full aspect-square object-cover transition-transform duration-500 group-hover:scale-[1.03]" loading="lazy" data-id="element-45" />
                </div>

                {/* Content */}
                <div className="pt-5 md:pt-6" data-id="element-46">
                  <div className="flex items-center gap-3 mb-2" data-id="element-47">
                    <span className="text-gold-500 font-bold tracking-widest uppercase text-sm" data-id="element-48">
                      Bonus #{bonus.id}
                    </span>
                    <span className="text-slate-500 text-xs font-medium border border-slate-700 rounded-full px-2.5 py-0.5" data-id="element-49">
                      VALUE {bonus.value}
                    </span>
                  </div>

                  <h3 className="font-display text-2xl md:text-3xl text-white uppercase leading-tight mb-4" data-id="element-50">
                    {bonus.title}
                  </h3>

                  <ul className="space-y-3" data-id="element-51">
                    {bonus.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-52">
                        <CheckCircle2Icon className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-53" />
                        <span className="text-slate-300 text-base md:text-lg leading-snug" data-id="element-54">
                          {bullet}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 text-center" data-id="element-55">
          <div className="inline-block border border-gold-500/30 bg-gold-500/5 px-8 py-4 rounded-xl" data-id="element-56">
            <span className="text-gold-500 font-bold tracking-widest uppercase" data-id="element-57">
              {bonuses.extraCallout}
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}